/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Customer_DisplayInputs */

const vi_nav_customer_display = /** @type {(inputs: Nav_Customer_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Màn hình khách`)
};

/**

* @param {Nav_Customer_DisplayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_customer_display = /** @type {((inputs?: Nav_Customer_DisplayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Customer_DisplayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_customer_display(inputs)
});